module.exports = __webpack_public_path__ + "startpage-746fed5a/cover-letter-1-preview-d69fa21cc97e7b7feb470976fb6a2bfe.jpg";